import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'zipCode',
    standalone: false
})
export class ZipCodePipe implements PipeTransform {
  private readonly hyphenPosition = 5;

  transform(value: string): string {
    const zip = (value?.toString() || '').replace(/\D/g, '');

    return zip.length > this.hyphenPosition
      ? zip.substring(0, this.hyphenPosition) + '-' + zip.substring(this.hyphenPosition)
      : zip;
  }

}
